import { moveToOnboarding } from '../../../../services/popupApi';

export const api = {
  submit: async (values, context) => {
    await moveToOnboarding({
      submissionId: context.selectedIds[0],
      isMail: values.sendOnboardingEmail,
    });
  },
};
